import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const scrollToDownload = () => {
    const el = document.getElementById('download');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    if (window.gtag) {
      window.gtag('event', 'click', { event_category: 'engagement', event_label: 'hero_cta_button' });
    }
  };

  return (
    <section className="hero" role="banner" aria-label="LITSCAN hero section">
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-orb hero-orb-1"></div>
        <div className="hero-orb hero-orb-2"></div>
        <div className="hero-orb hero-orb-3"></div>
        <div className="hero-scanline"></div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">🔴 Live Now — City Feed Active</div>
            <h1 className="hero-title">
              <span className="hero-logo-word">LITSCAN</span>
              <br />
              <span className="hero-subtitle-line">Know Where to Go. <span className="neon-pink">Before You Pull Up.</span></span>
            </h1>
            <p className="hero-desc">
              LITSCAN shows you exactly which spots are lit in real time.
              Crowdsourced by the people already out — see what's popping, what's dead,
              and what's trending all on one simple screen.
            </p>
            <div className="hero-tagline">"Scan the night. Find the energy. Never waste a night again."</div>
            <nav className="hero-buttons" role="navigation" aria-label="Primary actions">
              <button onClick={scrollToDownload} className="btn btn-primary btn-large">
                🔥 Get Early Access
              </button>
              <a href="#how-it-works" className="btn btn-secondary btn-large">
                See How It Works
              </a>
            </nav>
            <div className="hero-beta-bar">
              <span>🎉 <strong>Beta testing now available!</strong> Download now on iOS (TestFlight) and Android</span>
            </div>
          </div>

          <div className="hero-visual" role="img" aria-label="LITSCAN live vibe map preview">
            <div className="phone-mockup">
              <div className="phone-frame">
                <div className="phone-screen">
                  <div className="mock-app">
                    <div className="mock-header">
                      <span className="mock-logo">LITSCAN</span>
                      <span className="mock-live">● LIVE</span>
                    </div>
                    <div className="mock-city-label">Milwaukee — Tonight</div>
                    <div className="mock-venues">
                      {/*
                        Venue data can be dynamically generated or passed as props
                        This is just a static example
                      */}
                      {['Club Onyx', 'The Rave', 'Drink Wisconsinbly', 'Nomad World Pub', 'Up-Down MKE'].map((venue, i) => (
                        <div className="mock-venue-row" key={i}>
                          <span className="mock-venue-name">{venue}</span>
                          <span className="mock-vibe-badge">
                            {i === 0 && 'INSANE'}
                            {i === 1 && 'LIT 🔥'}
                            {i === 2 && 'GOOD'}
                            {i === 3 && 'CHILL'}
                            {i === 4 && 'DEAD 💀'}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="mock-poll">
                      <span>⚡ Quick poll at Club Onyx:</span>
                      <em>"Is the DJ fire right now?"</em>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
